import { createFileRoute } from "@tanstack/react-router";
import { SiteHeader } from "@/components/SiteHeader";
import { SiteFooter } from "@/components/SiteFooter";
import { ThankYouNextSteps } from "@/components/ThankYouNextSteps";

export const Route = createFileRoute("/danke")({
  head: () => ({
    meta: [
      { title: "Danke, Ihre Anfrage ist eingegangen | Shopify Freelancer" },
      {
        name: "description",
        content:
          "Ihre Anfrage ist eingegangen. So geht es weiter: kurze Einschätzung zu Ihrem Vorhaben, empfohlener nächster Schritt und optional ein 30-Minuten-Gespräch.",
      },
      { name: "robots", content: "noindex, nofollow" },
      { property: "og:title", content: "Danke, Ihre Anfrage ist eingegangen" },
      {
        property: "og:description",
        content: "So geht es nach Ihrer Anfrage an den Shopify Freelancer weiter.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://shopify-freelancer.net/danke" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://shopify-freelancer.net/danke" }],
  }),
  component: DankePage,
});

function DankePage() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader />
      <main className="veil py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-5">
          <ThankYouNextSteps />
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}
